import { createSlice } from '@reduxjs/toolkit';

const privacyPolicySlice = createSlice({
  name: 'privacyPolicy',
  initialState: {
    trms: null,
    trmsCn: null,
  },
  reducers: {
    getPolicyVersionZone: () => {},
    getPolicyVersionZoneSuccess: (state, { payload }) => {
      state.trms = payload;
    },
    getPolicyVersionZoneFail: state => {
      state.trms = null;
    },
    getTermsCn: () => {},
    getTermsCnSuccess: (state, { payload }) => {
      state.trmsCn = payload;
    },
    getTermsCnFail: state => {
      state.trmsCn = null;
    },
  },
});

export const {
  getPolicyVersionZone,
  getPolicyVersionZoneSuccess,
  getPolicyVersionZoneFail,
  getTermsCn,
  getTermsCnSuccess,
  getTermsCnFail,
} = privacyPolicySlice.actions;
export default privacyPolicySlice.reducer;
